import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/i18n";

export const SITE_URL = "https://claracocoa.co.id";

// Update an existing static meta tag in place (index.html carries the defaults for
// no-JS scrapers) instead of appending a duplicate via Helmet.
const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export const Seo = ({ title, description, path = "/", image = "/clara-share.jpg", jsonLd }) => {
  const { lang } = useLang();
  const suffix = path === "/" ? "" : path;
  const canonical = `${SITE_URL}/${lang}${suffix}`;
  const img = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  const LOCALES = { en: "en_US", id: "id_ID", zh: "zh_CN" };

  useEffect(() => {
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:url"]', canonical);
    setMeta('meta[property="og:image"]', img);
    setMeta('meta[property="og:locale"]', LOCALES[lang] || "en_US");
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);
    setMeta('meta[name="twitter:image"]', img);
  }, [title, description, canonical, img, lang]);

  return (
    <Helmet>
      <html lang={lang === "zh" ? "zh-CN" : lang} dir="ltr" />
      <title>{title}</title>
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en${suffix}`} />
      <link rel="alternate" hrefLang="id" href={`${SITE_URL}/id${suffix}`} />
      <link rel="alternate" hrefLang="zh" href={`${SITE_URL}/zh${suffix}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/en${suffix}`} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
